var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { getRoofAreaFullInfoById } from '../../services/RoofAreaService';
import './../Calculator/calculator.scss';
import { RoofAreaProperties } from './RoofAreaProperties';
import { RoofAreaZoneDetail } from './RoofAreaZoneDetail';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var RoofAreaDetail = function (_ref) { var _roofAreaData$, _roofAreaData$0$RoofA, _roofAreaData$2, _roofAreaData$3; var roofAreaId = _ref.roofAreaId; var _a = useState(), data = _a[0], setData = _a[1]; useEffect(function () { var getRoofAreaById = function () { return __awaiter(void 0, void 0, void 0, function () { var roofArea; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0:
            if (!(roofAreaId > 0)) return [3 /*break*/, 2];
            return [4 /*yield*/, getRoofAreaFullInfoById(roofAreaId)];
        case 1:
            roofArea = _a.sent();
            setData(roofArea);
            _a.label = 2;
        case 2: return [2 /*return*/];
    }
}); }); }; getRoofAreaById(); }, [roofAreaId, JSON.stringify(data)]); var roofAreaData; if (data) {
    roofAreaData = data;
} return /*#__PURE__*/ _jsx(Box, { children: roofAreaData && /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(RoofAreaProperties, { roofAreaData: roofAreaData }), ((_roofAreaData$ = roofAreaData[0]) === null || _roofAreaData$ === void 0 ? void 0 : _roofAreaData$.RoofAreaWindPressures.length) > 0 && /*#__PURE__*/ _jsx(RoofAreaZoneDetail, { wallResult: (_roofAreaData$0$RoofA = (_roofAreaData$2 = roofAreaData[0]) === null || _roofAreaData$2 === void 0 ? void 0 : _roofAreaData$2.RoofAreaWallWindPressures) !== null && _roofAreaData$0$RoofA !== void 0 ? _roofAreaData$0$RoofA : [], roofAreaWindPressure: (_roofAreaData$3 = roofAreaData[0]) === null || _roofAreaData$3 === void 0 ? void 0 : _roofAreaData$3.RoofAreaWindPressures, calculatorVersion: roofAreaData[0].CalculatorVersion })] }) }); };
